import DialogDeliveryAddress from "./DialogDeliveryAddress";

export default {
    name     : 'dialog_delivery_address',
    component: DialogDeliveryAddress,
    dialog   : {
        'max-width': "700px",
        'persistent': true
    }
}
